var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trial-banner"},[_c('div',{staticClass:"trial-banner-surface",attrs:{"aria-hidden":"true"}},[_c('canvas',{ref:"canvas",staticClass:"trial-banner-ascii"})])])}
var staticRenderFns = []

export { render, staticRenderFns }